import { useState, useEffect } from 'react';
import { AlertCircle } from 'lucide-react';

const AgeVerification = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already verified age
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setIsVisible(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setIsVisible(false);
    // Trigger storage event so cookie consent can react
    window.dispatchEvent(new Event('storage'));
  };

  const handleDecline = () => {
    // Redirect to responsible gaming page or show message
    window.location.href = '/responsible-gaming';
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
      <div className="bg-regal-gray rounded-xl border-2 border-regal-red max-w-md w-full p-8 relative">
        <div className="flex items-center gap-3 mb-6">
          <AlertCircle className="w-10 h-10 text-regal-red" />
          <h2 className="text-2xl font-bold text-white">Age Verification Required</h2>
        </div>
        
        <p className="text-gray-300 mb-6 leading-relaxed">
          You must be 18 or older to access this website. Online gambling is restricted to adults only in the United Kingdom.
        </p>
        
        <p className="text-gray-300 mb-8 leading-relaxed">
          By clicking "I am 18 or older", you confirm that you meet the legal age requirement for gambling in your jurisdiction.
        </p>

        <div className="flex gap-4">
          <button
            onClick={handleConfirm}
            className="flex-1 bg-regal-red hover:bg-red-700 text-white py-3 px-6 rounded-lg font-semibold transition-all"
          >
            I am 18 or older
          </button>
          <button
            onClick={handleDecline}
            className="flex-1 border-2 border-gray-600 hover:border-gray-500 text-gray-300 py-3 px-6 rounded-lg font-semibold transition-all"
          >
            I am under 18
          </button>
        </div>

        <p className="text-xs text-gray-500 mt-6 text-center">
          Please gamble responsibly. If you need help, visit BeGambleAware.org
        </p>
      </div>
    </div>
  );
};

export default AgeVerification;

